


















































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import CouponSelect from "@/components/coupon-select/index.vue";
import Api from "@/api/mall/mallConfig/index";
@Component({
  components: {
    CouponSelect,
  },
})
export default class RewardPointRuleSetting extends Vue {
  formData = {
    register: 0,
    order: 0,
    signIn: 0,
    birthDay: 0,
    coupons: null,
    deduct: 0,
    // rewardCoupons: [],
  };
  currentMonth: string = "0";
  get columns() {
    return [
      {
        title: "优惠券名称",
        key: "name",
      },
      {
        title: "优惠券类型",
        key: "couponTypeDisplayName",
      },
      {
        title: "面额/折扣",
        key: "discountValue",
      },
      {
        title: "赠送数量",
        key: "quantity",
        render: (h, params) => {
          console.log("buggggg", params, this.formData.coupons);
          return h("InputNumber", {
            props: {
              value: this.formData.coupons[this.currentMonth].list[params.index]
                ? this.formData.coupons[this.currentMonth].list[params.index]
                    .quantity
                : 0,
              min: 0,
            },
            on: {
              "on-change": (event: number) => {
                this.formData.coupons[this.currentMonth].list[
                  params.index
                ].quantity = event;
              },
            },
          });
        },
      },
      {
        title: "操作",
        key: "action",
        slot: "action",
      },
    ];
  }
  // get rewardColumns() {
  //   return [
  //     {
  //       title: '优惠券名称',
  //       key: 'name',
  //     },
  //     {
  //       title: '优惠券类型',
  //       key: 'couponTypeDisplayName',
  //     },
  //     {
  //       title: '面额/折扣',
  //       key: 'discountValue',
  //     },
  //     {
  //       title: '赠送数量',
  //       key: 'quantity',
  //       render: (h, params) => {
  //         return h('InputNumber', {
  //           props: {
  //             value: this.formData.rewardCoupons[params.index] ? this.formData.rewardCoupons[params.index].quantity : 0,
  //             min: 0,
  //           },
  //           on: {
  //             'on-change': (event: number) => {
  //               this.formData.rewardCoupons[params.index].quantity = event
  //             },
  //           },
  //         })
  //       },
  //     },
  //     {
  //       title: '操作',
  //       key: 'action',
  //       slot: 'action',
  //     },
  //   ]
  // }
  get couponIds() {
    return this.formData.coupons[this.currentMonth].list.map((x) => x.id);
  }
  tabRender = (data) => {
    return (h) => {
      return h("div", [
        h("span", `${data.month}月`),
        h("Badge", {
          props: {
            count: data.list.length,
          },
        }),
      ]);
    };
  };
  // get rewardCouponIds() {
  //   let arr =
  //     this.formData.rewardCoupons && this.formData.rewardCoupons.length
  //       ? this.formData.rewardCoupons.map((x) => x.id)
  //       : []
  //   return arr
  // }
  mounted() {
    this.loadData();
  }
  loadData() {
    Api.getMallConfig("RewardPointRuleConfig").then((res) => {
      if (res.data) {
        // if(!res.data.rewardCoupons) {
        //   res.data.rewardCoupons = []
        // }
        // if (!res.data.coupons.length) {
        //   for (let i = 1; i <= 12; i++) {
        //     res.data.coupons.push({
        //       month: i,
        //       list: [],
        //     });
        //   }
        // }
        this.formData = res.data;
      }
    });
  }
  save() {
    Api.updateMallConfig(
      "RewardPointRuleConfig",
      "积分规则配置",
      this.formData
    ).then((res) => {
      this.$Message.success("保存成功");
    });
  }
  deleteItems(index, type) {
    if (type === "birth") {
      this.formData.coupons[this.currentMonth].list.splice(index, 1);
    }
    // else {
    //   this.formData.rewardCoupons.splice(index, 1)
    // }
  }
  onCouponChange(e, type, index) {
    if (type === "birth") {
      this.formData.coupons[index].list = this.formData.coupons[
        index
      ].list.concat(
        e.map((t) => {
          return {
            id: t.id,
            code: t.code,
            name: t.name,
            couponTypeDisplayName: t.couponTypeDisplayName,
            discountValue: t.discountValue,
            quantity: 0,
          };
        })
      );
    }
    // else {
    //   if (!this.formData.rewardCoupons) {
    //     this.formData.rewardCoupons = []
    //   }
    //   console.log('执行了这里', e, type, this.formData.rewardCoupons);
    //   this.formData.rewardCoupons = this.formData.rewardCoupons.concat(
    //     e.map((t) => {
    //       return {
    //         id: t.id,
    //         code: t.code,
    //         name: t.name,
    //         couponTypeDisplayName: t.couponTypeDisplayName,
    //         discountValue: t.discountValue,
    //         quantity: 0,
    //       }
    //     })
    //   )
    // }
  }
}
